import React, {useEffect, useRef, useState} from 'react';
import styles from './index.module.less';
import {
  Alignment,
  Button,
  Classes,
  Collapse,
  Icon, Menu, MenuItem, ContextMenu,
  NavbarGroup,
  Tree, Dialog, InputGroup
} from "@blueprintjs/core";
import {useDispatch, useSelector} from "react-redux";
import constant from "../../store/constant";
import classes from 'classnames';
import { v4 } from 'uuid';


const isFile = (dom) => {
  if (dom.classList.contains('file')) {
    return true;
  }
  if (dom.classList.contains('tree-root')) {
    return false;
  }
  return isFile(dom.parentNode);
};

const isFolder = (dom) => {
  if (dom.classList.contains('folder')) {
    return true;
  }
  if (dom.classList.contains('file')) {
    return false;
  }
  if (dom.classList.contains('tree-root')) {
    return false;
  }
  return isFolder(dom.parentNode);
};

const generateFolderData = (label) => {
  return {
    id: v4(),
    icon: 'folder-close',
    label,
    className: classes(Classes.TEXT_SMALL ,'folder'),
    isExpanded: true,
  }
};
const generateFileData = (label) => {
  return {
    id: v4(),
    icon: "document",
    label,
    className: classes(Classes.TEXT_SMALL, 'file'),
    isSelected: false
  }
};

const Playground = () => {
  const contextMenuNode = useRef(null);
  const filesTree = useRef(null);
  const [createFolderDialogOpen, setCreateFolderDialogOpen] = useState(false);
  const [createFileDialogOpen, setCreateFileDialogOpen] = useState(false);
  useEffect(() => {
    filesTree.current.oncontextmenu = (e) => {
      e.preventDefault();
      let menu = null;
      if (isFile(e.target)) {
        menu = (
          <Menu>
            <MenuItem icon='label' text="重命名" onClick={handleContextMenuDelete} />
            <MenuItem icon='trash' text="删除文件" onClick={handleContextMenuDelete} />
          </Menu>
        );
      } else if (isFolder(e.target)) {
        menu = (
          <Menu>
            <MenuItem icon='new-text-box' text="新建文件" onClick={() => setCreateFileDialogOpen(true)} />
            <MenuItem icon='folder-new' text="新建目录" onClick={() => setCreateFolderDialogOpen(true)} />
            <MenuItem icon='trash' text="删除当前目录" onClick={handleContextMenuDelete} />
          </Menu>
        );
      } else {
        menu = (
          <Menu>
            <MenuItem icon='folder-new' text="新建目录"  onClick={() => setCreateFolderDialogOpen(true)} />
          </Menu>
        );
      }
      if (menu === null) {
        return;
      }
      ContextMenu.show(menu, { left: e.clientX, top: e.clientY });
    }
  }, []);
  const playground = useSelector(state => state.playground);
  const dispatch = useDispatch();
  const handleCreateFolder = (e) => {
    if (e.which === 13) {
      const { value } = e.target;
      setCreateFolderDialogOpen(false);
      if (contextMenuNode.current === null) {
        playground.files.push(generateFolderData(value));
      } else {
        if (!contextMenuNode.current.childNodes) {
          contextMenuNode.current.childNodes = [];
        }
        contextMenuNode.current.childNodes.push(generateFolderData(value));
      }
      dispatch({
        type: constant.playground.UPDATE_FILES,
        payload: [...playground.files]
      });
      contextMenuNode.current = null;
    }
  };
  const handleCreateFile = (e) => {
    if (!contextMenuNode.current) {
      return;
    }
    if (e.which === 13) {
      const { value } = e.target;
      setCreateFileDialogOpen(false);
      if (!contextMenuNode.current.childNodes) {
        contextMenuNode.current.childNodes = [];
      }
      contextMenuNode.current.childNodes.push(generateFileData(value));
      dispatch({
        type: constant.playground.UPDATE_FILES,
        payload: [...playground.files]
      });
      contextMenuNode.current = null;
    }
  };
  const handleContextMenuDelete = () => {
    console.log('删除', contextMenuNode.current);
  };

  const handleToggleFiles = () => {
    dispatch({
      type: constant.playground.TOGGLE_FILES
    });
  };
  const traversalNodesAndSelect = (nodeList, node) => {
    if (!nodeList || nodeList.length === 0) {
      return;
    }
    for (let i = 0, len = nodeList.length; i < len; i++) {
      const curNode = nodeList[i];
      if (typeof curNode.isExpanded === 'boolean') {
        traversalNodesAndSelect(curNode.childNodes, node);
      } else {
        curNode.isSelected = curNode.id === node.id;
      }
    }
  };
  const handleNodeClick = (node) => {
    if (typeof node.isExpanded === 'boolean') {
      node.isExpanded = !node.isExpanded;
    } else {
      traversalNodesAndSelect(playground.files, node);
    }
    dispatch({
      type: constant.playground.UPDATE_FILES,
      payload: [...playground.files]
    });
  };
  const handleNodeContextMenu = (node) => {
    traversalNodesAndSelect(playground.files, node);
    dispatch({
      type: constant.playground.UPDATE_FILES,
      payload: [...playground.files]
    });
    contextMenuNode.current = node;
  };
  const renderCreateFolderDialog = () => {
    return (
      <Dialog onClose={() => setCreateFolderDialogOpen(false)} className={styles.dialog} canEscapeKeyClose canOutsideClickClose usePortal isOpen={createFolderDialogOpen} backdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, .2)' } }}>
        <InputGroup onKeyPress={handleCreateFolder} leftIcon='folder-new' placeholder='请输入目录名' large />
      </Dialog>
    )
  };
  const renderCreateFileDialog = () => {
    return (
      <Dialog onClose={() => setCreateFileDialogOpen(false)} className={styles.dialog} canEscapeKeyClose canOutsideClickClose usePortal isOpen={createFileDialogOpen} backdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, .2)' } }}>
        <InputGroup onKeyPress={handleCreateFile} leftIcon='document' placeholder='请输入文件名' large />
      </Dialog>
    )
  };

  return (
    <div className={styles.playground}>
      <div className={styles.toolbar}>
        <NavbarGroup>
          <Button className={Classes.MINIMAL}>文件</Button>
          <Button className={Classes.MINIMAL}>编辑</Button>
          <Button className={Classes.MINIMAL}>选择</Button>
          <Button className={Classes.MINIMAL}>帮助</Button>
        </NavbarGroup>
        <NavbarGroup align={Alignment.RIGHT}>
          <Button className={Classes.MINIMAL} icon='fullscreen' />
        </NavbarGroup>
      </div>
      <div className={styles.body}>
        <div className={styles.files}>
          <div className={styles.header} onClick={handleToggleFiles}>
            <Icon className={styles.icon} icon={playground.filesExpand ? 'caret-down' : 'caret-right'} />
            <span className={styles.label}>Files</span>
          </div>
          <div className={classes(styles.tree, 'tree-root')} ref={filesTree}>
            <Collapse isOpen={playground.filesExpand}>
              <Tree contents={playground.files} onNodeClick={handleNodeClick} onNodeContextMenu={handleNodeContextMenu} />
            </Collapse>
          </div>
        </div>
      </div>
      {renderCreateFolderDialog()}
      {renderCreateFileDialog()}
    </div>
  );
};


export default Playground;
